import { useMemo } from "react";
import moment from "moment";
import { useGetOperationalLogs } from "@/services";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const useAuditLog = () => {
  const {communityData, currentFinanceYear } = useSelector((state: RootState) => state.currentData);

  const {data: logs, isLoading: isLoadingLogs} = useGetOperationalLogs({
    communityId: communityData?.communityId,
    fiscalYear: currentFinanceYear
  })

  const columns = useMemo(
    () => [
      { 
        accessorKey: "createdAt", 
        header: "Timestamp",
        accessorFn: (row: any) => row?.createdAt ? moment(row?.createdAt).format('MM/DD/YYYY') : ''
      },
      { accessorKey: "user", header: "User", accessorFn: (row: any) => row?.createdByName || ''},
      { accessorKey: "action", header: "Action" },
      { accessorKey: "systemRef", header: "System Ref" },
      { 
        accessorKey: "reason", 
        header: "Reason" 
      },
    ],
    []
  );

  return {
    columns,
    isLoadingLogs,
    logs
  };
};

export default useAuditLog;